module.exports = __webpack_public_path__ + "fonts/Mukta-300-devanagari4.1fd06a5.woff2";